<div [class]="classPrefix('MainPod')">
  <section [class]="classPrefix('Pod0')">
    <input [class]="classPrefix('Pod0Input0')" type="radio" [checked]="props.wmlOptionItem.isChosen"/>
    <div
    (click)="props.wmlOptionItem?.clickPredicate?.($any(props.wmlOptionItem))"
    [class]="classPrefix('Pod0Input0Helper') + props.wmlOptionItem?.class" ></div>
    <h4 [class]="classPrefix('Pod0Text0')">{{props.wmlOptionItem.text | translate}}</h4>
  </section>
</div>
